export default "/images/e5db57630ccc0a98c3d9538503adf591.avif";